// Generated using typescript-generator version null on 2019-05-02 17:46:56.

import { NeqHttpClient as HttpClient } from './http-client.config';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SharedPagedRequest } from '@sharedcommon/model/shared-page-request.model';
import { SharedPagedResponse } from '@sharedcommon/model/shared-paged-response.model';
import { environment } from '@sharedenvironment';

export class TechnicalMetaDto {
  key?: string;
  value?: string;
}

export class LangDto {
  id?: string;
  code?: string;
  label?: string;
  active?: boolean;
}

export class HttpEntity<T> {
  headers?: { [index: string]: any };
  body?: T;
}

export class ResponseEntity<T> extends HttpEntity<T> {
  statusCodeValue?: number;
  statusCode?: HttpStatus;
}

export class LogDto {
  app?: string;
  level?: string;
  code?: string;
  message?: string;
}

export class TranslationDto {
  id?: string;
  langCode?: string;
  key?: string;
  value?: string;
  modelValue?: string;
}

export class AppTranslationFilterDto extends SharedPagedRequest {
  key?: string;
  valueDefault?: string;
  langModel?: string;
  langToTranslate: string;
  type?: string;
}

export class SortOrder {
  field?: string;
  asc?: boolean;
}

export class AppTranslationDto {
  key?: string;
  valueDefault?: string;
  valueModel?: string;
  valueToTranslate?: string;
}

export class TranslationLightDto {
  key?: string;
  value?: string;
}

@Injectable()
export class TechnicalServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /technical/metas/{key}
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getMeta
   */
  getMeta(key: string): RestResponse<TechnicalMetaDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/metas/${key}` });
  }

  /**
   * HTTP GET /technical/rights
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getRights
   */
  getRights(): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/rights` });
  }
}

@Injectable()
export class LangServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get list of lang
   * HTTP GET /langs/active
   * Java method: com.neovia.equadvice.technical.service.LangService.fetchActive
   */
  fetchActive(): RestResponse<LangDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`langs/active` });
  }

  /**
   * Get list of lang
   * HTTP GET /langs
   * Java method: com.neovia.equadvice.technical.service.LangService.fetchAll
   */
  fetchAll(): RestResponse<LangDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`langs` });
  }

  /**
   * Get lang by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /langs/{id}
   * Java method: com.neovia.equadvice.technical.service.LangService.get
   */
  get(id: string): RestResponse<LangDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`langs/${id}` });
  }

  /**
   * Update lang
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /langs
   * Java method: com.neovia.equadvice.technical.service.LangService.put
   */
  put(arg0: LangDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`langs`, data: arg0 });
  }
}

@Injectable()
export class LoggerServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create a log
   * HTTP POST /logs
   * Java method: com.neovia.equadvice.technical.service.LoggerService.create
   */
  create(arg0: LogDto): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`logs`, data: arg0 });
  }
}

@Injectable()
export class TranslationServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create translation
   * Response code 204 - Created
   * Response code 500 - Error
   * HTTP POST /translations
   * Java method: com.neovia.equadvice.technical.service.TranslationService.create
   */
  create(arg0: TranslationDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`translations`, data: arg0 });
  }

  /**
   * Get filtered & paged app translates
   * Response code 206 - Partial ranged translates
   * Response code 404 - Not found
   * HTTP GET /translations
   * Java method: com.neovia.equadvice.technical.service.TranslationService.fetch
   */
  fetch(arg0: AppTranslationFilterDto): RestResponse<SharedPagedResponse<AppTranslationDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`translations`, data: arg0 });
  }

  /**
   * Search all translation for a languages or/and an application
   * HTTP GET /translations/light
   * Java method: com.neovia.equadvice.technical.service.TranslationService.fetchLight
   */
  fetchLight(queryParams?: { langCode?: string; appCode?: string; }): RestResponse<TranslationLightDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`translations/light`, queryParams: queryParams });
  }

  /**
   * Get one translation for a lang
   * HTTP GET /translations/{lang}/{key}
   * Java method: com.neovia.equadvice.technical.service.TranslationService.get
   */
  get(lang: string, key: string): RestResponse<TranslationDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`translations/${lang}/${key}` });
  }
}

export type RestResponse<R> = Observable<R>;

export type HttpStatus = 'CONTINUE' | 'SWITCHING_PROTOCOLS' | 'PROCESSING' | 'CHECKPOINT' | 'OK' | 'CREATED' | 'ACCEPTED' | 'NON_AUTHORITATIVE_INFORMATION' | 'NO_CONTENT' | 'RESET_CONTENT' | 'PARTIAL_CONTENT' | 'MULTI_STATUS' | 'ALREADY_REPORTED' | 'IM_USED' | 'MULTIPLE_CHOICES' | 'MOVED_PERMANENTLY' | 'FOUND' | 'MOVED_TEMPORARILY' | 'SEE_OTHER' | 'NOT_MODIFIED' | 'USE_PROXY' | 'TEMPORARY_REDIRECT' | 'PERMANENT_REDIRECT' | 'BAD_REQUEST' | 'UNAUTHORIZED' | 'PAYMENT_REQUIRED' | 'FORBIDDEN' | 'NOT_FOUND' | 'METHOD_NOT_ALLOWED' | 'NOT_ACCEPTABLE' | 'PROXY_AUTHENTICATION_REQUIRED' | 'REQUEST_TIMEOUT' | 'CONFLICT' | 'GONE' | 'LENGTH_REQUIRED' | 'PRECONDITION_FAILED' | 'PAYLOAD_TOO_LARGE' | 'REQUEST_ENTITY_TOO_LARGE' | 'URI_TOO_LONG' | 'REQUEST_URI_TOO_LONG' | 'UNSUPPORTED_MEDIA_TYPE' | 'REQUESTED_RANGE_NOT_SATISFIABLE' | 'EXPECTATION_FAILED' | 'I_AM_A_TEAPOT' | 'INSUFFICIENT_SPACE_ON_RESOURCE' | 'METHOD_FAILURE' | 'DESTINATION_LOCKED' | 'UNPROCESSABLE_ENTITY' | 'LOCKED' | 'FAILED_DEPENDENCY' | 'UPGRADE_REQUIRED' | 'PRECONDITION_REQUIRED' | 'TOO_MANY_REQUESTS' | 'REQUEST_HEADER_FIELDS_TOO_LARGE' | 'UNAVAILABLE_FOR_LEGAL_REASONS' | 'INTERNAL_SERVER_ERROR' | 'NOT_IMPLEMENTED' | 'BAD_GATEWAY' | 'SERVICE_UNAVAILABLE' | 'GATEWAY_TIMEOUT' | 'HTTP_VERSION_NOT_SUPPORTED' | 'VARIANT_ALSO_NEGOTIATES' | 'INSUFFICIENT_STORAGE' | 'LOOP_DETECTED' | 'BANDWIDTH_LIMIT_EXCEEDED' | 'NOT_EXTENDED' | 'NETWORK_AUTHENTICATION_REQUIRED';

export type TextMatchMode = 'STRICT' | 'CONTAINS';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = environment.technical.baseUrl;
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}
